import React from "react";
import {
  Facebook,
  Instagram,
  MailOutline,
  PhoneAndroidOutlined,
  Twitter,
  WhatsApp,
} from "@material-ui/icons";
import { FaLinkedin } from "react-icons/fa";

function SocialHeadings() {
  return (
    <div>
      <div className="container-fluid p-0">
        <div className="EmailNavHeader">
          <div className="EmaiPhoneDisplay">
            <div className="IconContainer">
              <a
                href="https://www.facebook.com/profile.php?id=100092700216336"
                className="ClickLink2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Facebook className="MediaIcon facebook" />
              </a>

              <a
                href=" https://www.linkedin.com/groups/13021030"
                className="ClickLink2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin className="MediaIcon twitter" />
              </a>

              <a
                href="https://www.instagram.com/unilagalumniuk?igsh=ZHA1ZXR0dm9oa3dz&utm_source=qr"
                className="ClickLink2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instagram className="MediaIcon Instagram" />
              </a>
            </div>

            <div className="InfoDisplay3003">
              <div className="InfoDisplay">
                <div>
                  <MailOutline />{" "}
                </div>
                <div className="EmailGap">info@unilagalumniuk.org</div>
              </div>
              <div className="InfoDisplay">
                <div>
                  <PhoneAndroidOutlined />
                </div>
                <div>+447592893361</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SocialHeadings;
